exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-profile-page-js": () => import("./../../../src/templates/profile-page.js" /* webpackChunkName: "component---src-templates-profile-page-js" */)
}

